<template>
  <v-navigation-drawer
    app
    permanent
    clipped
    bottom
    width="350"
  >
    <v-row style="height: 100%">
      <v-col>
        <LayerMenu />
      </v-col>
    </v-row>
    <v-footer
      absolute
      padless
    >
      <v-card
        flat
        tile
        width="100%"
        class="text-center"
      >
        <v-card-text class="py-1">
          <a
            href="https://www.spicetech.de/#Impressum"
            target="_blank"
          >Impressum</a>/<a
            href="https://www.spicetech.de/datenschutzerklaerung"
            target="_blank"
          >Datenschutz</a>/<a
            href="mailto:quanticy@spicetech.de"
            target="_blank"
          >Support</a>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import LayerMenu from "@/components/LayerMenu";

export default {
  name: "MapMenu",
  components: { LayerMenu }
};
</script>

<style></style>
